/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9hZG1pbi9oZWxwL3RyYWluaW5nLXZpZGVvcy90cmFpbmluZy12aWRlb3MtZGFzaGJvYXJkL3RyYWluaW5nLXZpZGVvcy1kYXNoYm9hcmQuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvd3d3L2h0bWwvTXlEZXNpZ25WMy9odG1sL3NyYy9hcHAvYWRtaW4vaGVscC90cmFpbmluZy12aWRlb3MvdHJhaW5pbmctdmlkZW9zLWRhc2hib2FyZC90cmFpbmluZy12aWRlb3MtZGFzaGJvYXJkLmNvbXBvbmVudC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/admin/help/training-videos/training-videos-dashboard/training-videos-dashboard.component.css.shim.ngstyle.ts